import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { PlanningAttendance } from '~/components/routes/hr/planning/attendance'
import { ExportAttendanceButton } from '~/components/routes/hr/planning/attendance/export-attendance-button'
import { HrAttendanceSelector } from '~/components/routes/hr/planning/hr-attendance-selector'
import { HrSlotPortal } from '~/components/routes/hr/planning/hr-toolbar-slot'
import { CLOCKING_READ } from '~/components/routes/hr/tabs'
import { useFeatureFlag } from '~/hooks/useFeatureFlag'
import { resolveAttendanceRange } from '~/utils/dates/attendance-range'
import { resolveStoreSet } from '~/utils/hr/resolveStoreSet'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/planning/attendance')({
  staticData: {
    permission: CLOCKING_READ,
  },
  component: RouteComponent,
  validateSearch: z.object({
    // Plage de dates pilotant à la fois le tableau et l'export (ISO 'YYYY-MM-DD').
    dateStart: z.string().optional(),
    dateEnd: z.string().optional(),
  }),
})
withRoutePermissions(Route)

function RouteComponent() {
  const { storeId, exportStoreIds, dateStart, dateEnd } = Route.useSearch()
  const attendanceMultiStore = useFeatureFlag('hr-export-attendance-multi-store')

  // Plage partagée tableau + export ; défaut = semaine courante quand l'URL est vide.
  const attendanceRange = resolveAttendanceRange(dateStart, dateEnd)

  // Multi-boutique : affichage mono via storeId, export sur tout le set (`exportStoreIds`), fallback
  // sur la boutique unique. `[]` ⇒ undefined = « aucun filtre » = toutes les boutiques.
  const resolvedExportSet = resolveStoreSet(storeId, exportStoreIds)
  const exportStoreSet = resolvedExportSet.length > 0 ? resolvedExportSet : undefined
  const singleStoreSet = storeId === undefined ? undefined : [storeId]
  const attendanceExportSet = attendanceMultiStore ? exportStoreSet : singleStoreSet

  return (
    <>
      <HrSlotPortal name="toolbar">
        <HrAttendanceSelector />
        <ExportAttendanceButton
          storeIds={attendanceExportSet}
          dateStart={attendanceRange.dateStart}
          dateEnd={attendanceRange.dateEnd}
        />
      </HrSlotPortal>
      <PlanningAttendance />
    </>
  )
}
